/* global grecaptcha */
/* global chrome */

import { initializeApp } from "firebase/app";
import { getAuth, signInWithPhoneNumber, signOut, RecaptchaVerifier } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import config from "./config";

const app = initializeApp(config);
export const auth = getAuth();
const functions = getFunctions(app);

export function logout() {
  return signOut(auth);
}

export function sendRequestForCode(phoneNumber) {
  console.log('firebase.js - sendRequestForCode')
  initRecaptcha();
  const appVerifier = window.recaptchaVerifier;
  const validatedPhoneNumber = phoneNumber
    .replaceAll("(", "")
    .replaceAll(")", "")
    .replaceAll(" ", "")
    .replaceAll("-", "")

  return signInWithPhoneNumber(auth, validatedPhoneNumber, appVerifier)
    .then((confirmationResult) => {
      window.confirmationResult = confirmationResult;
      resetRecaptcha();

      return confirmationResult;
    })
    .catch((error) => {
      resetRecaptcha();

      throw error;
    });
}

export function initRecaptcha() {
  console.log('firebase.js - initRecaptcha')
  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new RecaptchaVerifier("recaptcha-container", {
      "size": "invisible",
    }, auth);
  }
}

export function resetRecaptcha() {
  console.log('firebase.js - resetRecaptcha')

  return window.recaptchaVerifier.render().then((widgetId) => {
    window.recaptchaVerifier.clear()
    return grecaptcha.reset(widgetId);
  });
}